export default {
	attributes: {
		design: 'basic',
		columns: 1,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showImage: true,
		imageSize: 'large',
		imageBackgroundWidthUnit: '%',
		imageBackgroundTabletWidthUnit: '%',
		imageBackgroundMobileWidthUnit: '%',
		image1Id: 475,
		image1Url: 'https://source.unsplash.com/400x300/?abstract',
		title1: 'Title for This Block',
		showTitle: true,
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		subtitle1: 'Subtitle for This Block',
		showSubtitle: true,
		subtitleLineHeightUnit: 'em',
		subtitleTabletLineHeightUnit: 'em',
		subtitleMobileLineHeightUnit: 'em',
		description1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block.',
		showDescription: true,
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		showButton: true,
		buttonLineHeightUnit: 'em',
		buttonTabletLineHeightUnit: 'em',
		buttonMobileLineHeightUnit: 'em',
		button1LineHeightUnit: 'em',
		button1TabletLineHeightUnit: 'em',
		button1MobileLineHeightUnit: 'em',
		button1Text: 'Button text',
		button1NewTab: false,
		button2LineHeightUnit: 'em',
		button2TabletLineHeightUnit: 'em',
		button2MobileLineHeightUnit: 'em',
		button2NewTab: false,
		button3LineHeightUnit: 'em',
		button3TabletLineHeightUnit: 'em',
		button3MobileLineHeightUnit: 'em',
		button3NewTab: false,
		uniqueClass: 'ugb-7974b2e',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
